
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default Vue.extend({
        components: { WhatsApp, XBreadcrumb },
        name: 'TravelAssistancePassengers',
        data() {
            return {
                planDescription: '',
                planPrice: '',
                covers: [],
                breadcrumbItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Pasajeros', path: '/asistencia-viajero/pasajeros' },
                ],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                documentTypeList: [{ id: "", text: "" }],
                maxSelections: 2,
                passengersCount: 1,
                passengers: [],
                // Modal state
                newPassenger: {
                    firstName: '',
                    lastName: '',
                    docType: null,
                    docNum: '',
                    birthday: null,
                },
                passengerFoundInBUP: false,
                showManualPassengerForm: false,
                messageErrorPassengerAdd: '',
                messageErrorDuplicate: '',
                messageErrorPassengers: '',
                referente: null,
            }
        },
        computed: {
            canConfirmPassenger() {
                return this.newPassenger.firstName && this.newPassenger.lastName
                    && this.newPassenger.docType && this.newPassenger.docNum
                    && this.newPassenger.birthday
                    && !this.messageErrorDuplicate;
            },
        },
        methods: {
            formatDate(date) {
                if (!date) return '';
                var d = new Date(date);
                return d.getDate().toString().padStart(2, '0') + '/' + (d.getMonth() + 1).toString().padStart(2, '0') + '/' + d.getFullYear();
            },

            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                } catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.pageCustomization()]);
                }
            },

            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element => ({ ...element, id: element["id"], text: element["name"] }));
                    }
                })
            },

            openAddPassengerModal() {
                this.newPassenger = {
                    firstName: '',
                    lastName: '',
                    docType: this.documentTypeList.find(p => p.name && p.name.trim() == "DNI") || null,
                    docNum: '',
                    birthday: null,
                };
                this.passengerFoundInBUP = false;
                this.showManualPassengerForm = false;
                this.messageErrorPassengerAdd = '';
                this.messageErrorDuplicate = '';
                this.$refs.addPassengerModal.open();
            },

            closeAddPassengerModal() {
                this.$refs.addPassengerModal.close();
            },

            searchPassengerBUP() {
                this.passengerFoundInBUP = false;
                this.showManualPassengerForm = false;
                this.messageErrorPassengerAdd = '';
                this.messageErrorDuplicate = '';

                // Verificar duplicado
                var isDuplicate = this.passengers.some(p => p.docNum == this.newPassenger.docNum && p.docType.id == this.newPassenger.docType.id);
                if (isDuplicate) {
                    this.messageErrorDuplicate = 'Este pasajero ya fue agregado.';
                    return;
                }

                NF.UI.Page.blockCustom({ message: 'Buscando datos..' });
                searchPersonService.GetSearchPersonData(this.newPassenger.docNum, this.newPassenger.docType.id)
                    .then(response => {
                        let result = response.searchPersonResult[0];
                        if (result != undefined && result.firstName != "" && result.lastName != "") {
                            this.newPassenger.firstName = result.firstName;
                            this.newPassenger.lastName = result.lastName;
                            this.newPassenger.birthday = result.birthday;
                            this.passengerFoundInBUP = true;
                            this.showManualPassengerForm = false;
                        } else {
                            this.passengerFoundInBUP = false;
                            this.showManualPassengerForm = true;
                            this.newPassenger.firstName = '';
                            this.newPassenger.lastName = '';
                            this.newPassenger.birthday = null;
                        }
                    })
                    .catch(() => {
                        this.showManualPassengerForm = true;
                    })
                    .finally(() => NF.UI.Page.unblock());
            },

            confirmAddPassenger() {
                this.messageErrorPassengerAdd = '';
                if (!this.newPassenger.firstName || !this.newPassenger.lastName || !this.newPassenger.docType || !this.newPassenger.docNum || !this.newPassenger.birthday) {
                    this.messageErrorPassengerAdd = 'Completá todos los campos del pasajero.';
                    return;
                }
                // TODO: Validar edad según plan (Pareja ≤75, Familia: adultos 21-75, menores <21)
                this.passengers.push({ ...this.newPassenger });
                sessionStorage.setItem("passengers", JSON.stringify(this.passengers));
                this.closeAddPassengerModal();
                this.messageErrorPassengers = '';
            },

            removePassenger(index) {
                this.passengers.splice(index, 1);
                sessionStorage.setItem("passengers", JSON.stringify(this.passengers));
            },

            anterior() {
                sessionStorage.setItem("pressBackFromPassengers", "true");
                this.$router.push({ name: 'travelAssistance-policyOwner' });
            },

            siguiente() {
                this.messageErrorPassengers = '';
                if (this.passengers.length < this.passengersCount) {
                    this.messageErrorPassengers = 'Debés cargar ' + this.passengersCount + ' pasajero/s para continuar.';
                    return;
                }
                NF.UI.Page.block();
                sessionStorage.setItem("passengers", JSON.stringify(this.passengers));
                window.globalThis.dataLayer.push({ 'product': 'asistencia-viajero', 'event': 'cotizador-viajero-pasajeros', 'referente': this.referente });
                this.$router.push({ name: 'travelAssistance-Summary' });
                NF.UI.Page.unblock();
            },

            openCancelModal() { this.$refs.cancelModal.open(); },
            closeCancelModal() { this.$refs.cancelModal.close(); },
            cancelAndRedirect() {
                this.closeCancelModal();
                this.$router.push({ name: 'travelAssistance-tab-One' });
            },

            loadPlanData() {
                var planData = sessionStorage.getItem("SelectedTravelPlan");
                if (planData) {
                    var plan = JSON.parse(planData);
                    this.planDescription = plan.name;
                    this.planPrice = plan.priceFormatted;
                    this.covers = plan.covers || [];
                }
                var travelData = sessionStorage.getItem("TravelDetailsData");
                if (travelData) {
                    this.passengersCount = JSON.parse(travelData).passengersCount || 1;
                }
                // Si el contratante viaja, agregarlo como primer pasajero
                var contractorTraveling = JSON.parse(sessionStorage.getItem("contractorTraveling"));
                var contratante = JSON.parse(sessionStorage.getItem("contratante"));
                var savedPassengers = sessionStorage.getItem("passengers");

                if (savedPassengers) {
                    this.passengers = JSON.parse(savedPassengers);
                } else if (contractorTraveling && contratante) {
                    this.passengers = [{
                        firstName: contratante.firstName,
                        lastName: contratante.lastName,
                        docType: contratante.documentType,
                        docNum: contratante.documentNumber,
                        birthday: contratante.birthday || null,
                    }];
                    sessionStorage.setItem("passengers", JSON.stringify(this.passengers));
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                await this.pageCustomization();
                this.getDocumentType();
                this.loadPlanData();
                sessionStorage.setItem("ExitOrContinueModal", "true");
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
